/*!
 * KoliBri - The accessible HTML-Standard
 */
import { L as Log } from './common-D-vggmh2.js';

const UNIQUE_LABELS = new Set();
function addNavLabel(ariaLabel) {
    if (UNIQUE_LABELS.has(ariaLabel)) {
        Log.warn(`There already is a nav element with the label "${ariaLabel}"`);
    }
    else {
        UNIQUE_LABELS.add(ariaLabel);
    }
}
function removeNavLabel(ariaLabel) {
    UNIQUE_LABELS.delete(ariaLabel);
}

export { addNavLabel as a, removeNavLabel as r };
//# sourceMappingURL=unique-nav-labels-B6_Oto5e.js.map

//# sourceMappingURL=unique-nav-labels-B6_Oto5e.js.map